import request from '@/utils/request';
import Resource from '@/api/resource';
class EnumResource extends Resource {
  constructor() {
    super('tool/enum');
  }

  // 查询枚举值
  getApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 创建枚举值
  creatApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 编辑枚举值
  editApi(data, id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'PUT',
      data,
    });
  }

  // 删除枚举值
  deleteApi(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'DELETE',
    });
  }
}
export { EnumResource as default };
